module.exports = __webpack_public_path__ + "static/media/linkedin.7d87950c.png";